import { requestGet } from '@/utils/request';

const api = {
    LIST: '/statistics/stat_agent_list'
};

export function statAgentList(params) {
    return requestGet(api.LIST, params);
}
